<template>
  <div class="flex" :class="getContainerClass()">
    <rpm-input-label v-bind="$attrs">
      <slot name="label"></slot>
    </rpm-input-label>

    <div :class="coreClass ? coreClass:flex">
      <slot name="helper">
        <span v-if="helper" :class="helperClass">
          {{ helper }}
        </span>
      </slot>

      <div :class="wrapperClass">
        <rpm-input-core
          v-bind="$attrs"
          :invalid="invalid"
          :placeHolderClass="getPlaceHolderClass()"
          :focusFocusClass="getFocusFocusClass()"
          :transitionClass="getTransitionClass()"
          :disabledClass="getDisabledClass()"
          :paddingClass="getPaddingClass()"
          :borderClass="getBorderClass()"
          :focusClass="getFocusClass()"
          :panelClass="getPanelClass()"
          :textClass="getTextClass()"
        ></rpm-input-core>
      </div>

      <slot name="post">
        <span v-if="post" :class="postClass">
          {{ post }}
        </span>
      </slot>
    </div>

    <rpm-input-error-list
      v-bind="$attrs"
      @is-invalid="setInvalid"
    ></rpm-input-error-list>
  </div>
</template>


<script>

import RpmInputCore from "./RpmInputCore.vue";
import RpmInputLabel from "./RpmInputLabel.vue";
import RpmInputErrorList from "./RpmInputErrorList.vue";

export default {
  name: "RpmInput",
  inheritAttrs: false,
  components: {
    RpmInputCore,
    RpmInputLabel,
    RpmInputErrorList
  },
  data() {
    return {
      invalid: false
    }
  },
  props: {
    flex: {
      type: String,
      default: "flex-col gap-y-1"
    },
    class: {
      type: String,
      default: ""
    },
    containerClass: {
      type: String,
      default: "",
    },
    wrapperClass: {
      type: String,
      default: "",
    },
    coreClass: {
      type: String,
      default: "",
    },
    helper: {
      type: String,
      default: "",
    },
    helperClass: {
      type: [String, Array, Object],
      default: "text-xxs text-default/80 dark:text-white/80",
    },
    post: {
      type: String,
      default: "",
    },
    postClass: {
      type: [String, Array, Object],
      default: "text-xxs text-default/80 dark:text-white/80",
    },
  },
  methods: {
    setInvalid(bool){
      this.invalid = bool;
    },
    getFocusClass(){
      return [
        "ring ring-offset-2 ring-offset-white dark:ring-offset-slate-900",
        !this.invalid ? "ring-theme/30":"ring-red-500/30"
      ].join(" ");
    },
    getFocusFocusClass(){
      return [
        "focus:ring focus:ring-offset-2 focus:ring-offset-white dark:focus:ring-offset-slate-900",
        !this.invalid ? "focus:ring-theme/30":"focus:ring-red-500/30"
      ].join(" ");
    },
    getDisabledClass(){
      return "text-default/75 dark:text-white/75 bg-gray-200 dark:bg-gray-800";
    },
    getBorderClass(){
      return [
        "border rounded",
        !this.invalid ? "border-gray-500/20 hover:border-theme/40":"border-red-500/80 hover:border-red-500"
      ].join(" ");
    },
    getPaddingClass(){
      return "px-3 py-2";
    },
    getTransitionClass(){
      return "transition-all";
    },
    getTextClass(){
      return `
        text-sm placeholder:italic placeholder:text-default/50 dark:placeholder:text-white/60 placeholder:text-xs
        disabled:text-default/75 dark:disabled:text-white/75 disabled:bg-gray-200 dark:disabled:bg-gray-800
      `;
    },
    getPlaceHolderClass(){
      return "italic text-default/50 dark:text-white/60 text-xs";
    },
    getPanelClass(){
      return "rounded bg-white dark:bg-slate-800 dark:text-white drop-shadow-lg overflow-y-auto";
    },
    getContainerClass(){
      return this.containerClass ? this.containerClass : [
        this.flex,
        this.class
      ];
    }
  }
};
</script>
